import "./Contact.module.css";
import EnTêteDeNavigation from "@/reusable_sections/Header";
import DiscutonsDeVosObjectifs from "./sections/DiscutonsDeVosObjectifs";
import FaqInstitutionnelle from "./sections/FaqInstitutionnelle";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <EnTêteDeNavigation />
      <DiscutonsDeVosObjectifs />
      <FaqInstitutionnelle />
      <Footer />
    </div>;
}